import React from "react"
import DfbHeadline from "../ui-kit/dfb_headline"
import DfbRte from "../ui-kit/dfb_rte"
import { wrapListItemContents } from "../utilities"
import { Image, Transformation } from "cloudinary-react"
import Section from "./section"

const MAuthorCollapsible = (props) => {
  return (
    <Section
      baseClass="m-Accordion"
      defaultPaddingTop="small"
      data={props.data}
    >
      <div className="m-Accordion-wrapper">
        <div className="m-Accordion-container">
          <div className="m-Accordion-content">
            <ol className="c-Accordion">
              <li
                className="c-Accordion-item"
                data-item={`author-accordion-${props.data.uid}`}
              >
                <button className="c-Accordion-button">
                  <span className="c-Accordion-buttonTitle">
                    {props.data.headline}
                  </span>
                  <span className="c-Accordion-icon">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                      <path
                        fill="currentColor"
                        d="M12 1C5.9 1 1 5.9 1 12s4.9 11 11 11 11-4.9 11-11S18.1 1 12 1zm0 20c-5 0-9-4-9-9s4-9 9-9 9 4 9 9-4 9-9 9z"
                      />
                      <path
                        className="horizontally"
                        fill="currentColor"
                        d="M6 11h12v2H6z"
                      />
                      <path
                        className="vertically"
                        fill="currentColor"
                        d="M13 6v12h-2V6z"
                      />
                    </svg>
                  </span>
                </button>

                <div className="c-Accordion-content">
                  <div
                    id={`author-accordion-${props.data.uid}`}
                    className="c-Accordion-author"
                  >
                    <div className="c-Author c-Author--numbers">
                      {props.data.author.authorPhoto &&
                        props.data.author_show_image === 1 && (
                          <Image
                            publicId={props.data.author.authorPhoto.src}
                            className="c-Author-image"
                            title={props.data.author.authorPhoto.title}
                            alt={props.data.author.authorPhoto.alternative}
                            data-object-fit
                            type="fetch"
                            cloudName="dfb-akademie-dev"
                          >
                            <Transformation
                              crop="fill"
                              gravity="faces:center"
                              width="100"
                              height="100"
                              quality="auto"
                              fetchFormat="auto"
                            />
                          </Image>
                        )}
                      <div className="c-Author-info">
                        <DfbHeadline
                          headline={`${props.data.author.firstname} ${props.data.author.lastname}`}
                          headline_level="h6"
                          add_class="c-Author-name"
                        />
                        {props.data.author.description && (
                          <DfbRte
                            text={wrapListItemContents(
                              props.data.author.description
                            )}
                            add_class="c-Author-description"
                          />
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </li>
            </ol>
          </div>
        </div>
      </div>
    </Section>
  )
}

export default MAuthorCollapsible
